export default __webpack_public_path__ + "static/media/MusicalIntruments_13.9b8171c7.png";